<template>
  <Box>
    <PageSubtitle :text="$t('subscription.manage.title')" />

    <p class="description">{{ $t('subscription.manage.description') }}</p>
    <p v-if="showLanguageAlert" class="description">{{ $t('subscription.manage.lang-alert') }}</p>

    <Button @click="openModal">{{ $t('common.contact-us') }}</Button>

    <ContactUsModal :active="showModal" @close="closeModal" />
  </Box>
</template>

<script type="ts">
  import { Box } from '@/ui/components/Box';
  import { Button } from '@/ui/components/Button';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { getLocale } from '@/ui/i18n/i18n';
  import ContactUsModal from '@/ui/pages/subscription/Chargebee/details/ContactUsModal.vue';
  import { defineComponent, computed, ref } from 'vue';

  export default defineComponent({
    components: { ContactUsModal, PageSubtitle, Box, Button },
    setup() {
      const showLanguageAlert = computed(() => {
        return !['en', 'de'].includes(getLocale());
      });

      const showModal = ref(false);

      const openModal = () => {
        showModal.value = true;
      };

      const closeModal = () => {
        showModal.value = false;
      };

      return {
        showLanguageAlert,
        openModal,
        closeModal,
        showModal,
      };
    },
  });
</script>
